export const settingsTranslation = {
  en: {
    settings: "Settings",
    home: "Home",
    landing: "Landing",
    configureLanding: "Configure your landing page settings.",
    account: "Account",
    manageAccount: "Manage your account settings.",
    tsaSettings: "TSA Settings",
    adjustDsgSettings: "Adjust your DSG settings.",
    careers: "Careers",
    exploreCareers: "Explore career opportunities.",
    jobs: "Jobs",
    exploreJobs: "Explore available job positions.",
    applicants: "Applicants",
    manageApplicants: "Manage job applicants.",
    blogs: "Blogs",
    manageBlogs: "Manage your blog posts.",
    news: "News",
    companyCertificate: "Company Certificate",
    viewCompanyCertifications: "View company certifications.",
    companyFiles: "Company Files",
    accessCompanyFiles: "Access company files.",
    memberships: "Memberships",
    manageMemberships: "Manage memberships.",
    services: "Services",
    exploreServices: "Explore our services.",
    contactUs: "Contact Us",
    getInTouch: "Get in touch with us.",
    faqs: "FAQs",
    frequentlyAskedQuestions: "Frequently asked questions.",
    ourValues: "Our Values",
    learnAboutValues: "Learn about our values.",
    newsletterSubscription: "Newsletter Subscription",
    manageNewsletterSubscriptions: "Manage newsletter subscriptions.",
    customPages: "Custom Pages",
    createManageCustomPages: "Create and manage custom pages.",
    customers: "Customers",
    manageCustomerInformation: "Manage customer information.",
    partners: "Partners",
    viewPartners: "View our partners.",
    teamMembers: "Team Members",
    meetTeamMembers: "Meet our team members.",
    tutorials: "Tutorials",
    accessTutorials: "Access tutorials.",
    pagesIntroductions: "Pages Introductions",
    managePagesIntroductions: "Manage all pages introductions.",
    socialMedia: "Social Media",
    manageSocialMediaLinks: "Manage social media links.",
    generalSettings: "General Settings",
    adjustGeneralSettings: "Adjust general settings.",
    "Manage Landing Slider ": "Manage Landing Slider",
    "SiteMap URL": "SiteMap URL",
    "Manage SiteMap URL ": "Manage SiteMap URL",
    "Adjust Landing General Settings": "Adjust Landing General Settings",
    "General Settings": "General Settings",
    "Configure General Settings": "Configure General Settings",
    DsgSettings: "DSG Settings",
    "Log copied to clipboard!": "Log copied to clipboard!",
    "Failed to copy log.": "Failed to copy log.",
    "Failed to download log.": "Failed to download log.",
    "Audit Logs": "Audit Logs",
    "Activity Type": "Activity Type",
    "Recipient": "Recipient",
    "Template": "Template",
    "User": "User",
    "Personalization": "Personalization",
    "Setting": "Setting",
    "Login": "Login",
    "Folder": "Folder",
    "Register": "Register",
    "Document": "Document",
    "Event Date": "Event Date",
    "View and manage audit logs": "View and manage audit logs",
    "Bulk Actions Logs": "Bulk Actions Logs",
    "View bulk actions logs": "View bulk actions logs",
    "Type of Action": "Type of Action",
    Summary: "Summary",
    Administrator: "Administrator",
    "Date and Time": "Date and Time",
    "No Bulk Actions": "No Bulk Actions",
    "There are no Bulk Actions to display":
      "There are no Bulk Actions to display",
    "View the status of pending and completed bulk actions. Download CSV logs of changes made":
      "View the status of pending and completed bulk actions. Download CSV logs of changes made",
    "Roles & Permissions": "Roles & Permissions",
    "Manage roles and permission access": "Manage roles and permission access",
    "Select a role to manage access": "Select a role to manage access",
    Roles: "Roles",
    Permissions: "Permissions",
    "Selected Role": "Selected Role",
    "Select a role to manage permissions":
      "Select a role to manage permissions",
    "All Permissions": "All Permissions",
    "Select All": "Select All",
    "Search permissions": "Search permissions",
    "Add Role": "Add Role",
    "Edit Role": "Edit Role",
    "Delete Role": "Delete Role",
    "Create Role": "Create Role",
    "Update Role": "Update Role",
    "Role Name": "Role Name",
    "Role Name (English)": "Role Name (English)",
    "Role Name (Arabic)": "Role Name (Arabic)",
    Create: "Create",
    Update: "Update",
    Cancel: "Cancel",
    "No roles found": "No roles found",
    "Untitled Role": "Untitled Role",
    "No permissions found": "No permissions found",
    "Save Permissions": "Save Permissions",
    "Saving...": "Saving...",
    "Please select a role first": "Please select a role first",
    "Role name is required": "Role name is required",
    "Delete this role?": "Delete this role?",
    "Failed to load roles and permissions":
      "Failed to load roles and permissions",
    "Failed to load role permissions": "Failed to load role permissions",
    "Failed to create role": "Failed to create role",
    "Role created successfully": "Role created successfully",
    "Failed to update role": "Failed to update role",
    "Role updated successfully": "Role updated successfully",
    "Failed to delete role": "Failed to delete role",
    "Role deleted successfully": "Role deleted successfully",
    "Failed to save permissions": "Failed to save permissions",
    "Permissions saved successfully": "Permissions saved successfully",
    "Roles & Permissions Icon": "Roles & Permissions Icon",
    "Document Retention": "Document Retention",
    "Manage document retention policies": "Manage document retention policies",
    "Document Retention Icon": "Document Retention Icon",
    "Bulk Actions Icon": "Bulk Actions Icon",
    "Audit Logs Icon": "Audit Logs Icon",
    "Account Icon": "Account Icon",
    "Right Arrow Icon": "Right Arrow Icon",
    "DsgSettings Icon": "DSG Settings Icon",
    "General Settings Icon": "General Settings Icon",
    "Download Backups": "Download Backups",
    "Download and manage system backups": "Download and manage system backups",
    "Download Backups Icon": "Download Backups Icon",
    "Backup for Workflow": "Backup for Workflow",
    "Backup for Landing": "Backup for Landing",
    "Backup Code": "Backup Code",
    "Backup DB Schema": "Backup DB Schema",
    "Backup Full DB": "Backup Full DB",
    "Export the application backend codebase as a downloadable archive.":
      "Export the application backend codebase as a downloadable archive.",
    "Export the database schema structure without full data.":
      "Export the database schema structure without full data.",
    "Export a complete database backup including all data.":
      "Export a complete database backup including all data.",
    "Generate and download system backups. Each export is prepared on demand and the download link is valid for a short time.":
      "Generate and download system backups. Each export is prepared on demand and the download link is valid for a short time.",
    "Preparing export...": "Preparing export...",
    "Downloading...": "Downloading...",
    Download: "Download",
    "Create New Export": "Create New Export",
    Retry: "Retry",
    "Failed to start export.": "Failed to start export.",
    "Failed to check export status.": "Failed to check export status.",
    "Failed to download export file.": "Failed to download export file.",
    "Export failed. Please try again.": "Export failed. Please try again.",
    "This export is taking longer than expected. Please try again later.":
      "This export is taking longer than expected. Please try again later.",
    "Document and Submission Retention Policy":
      "Document and Submission Retention Policy",
    "Set your account's document retention policy or purge individual submissions. Purging permanently removes documents from completed, declined, and expired submissions.":
      "Set your account's document retention policy or purge individual submissions. Purging permanently removes documents from completed, declined, and expired submissions.",
    "To start, the submission is added to the purge queue. After the waiting period ends, the submission is purged.":
      "To start, the submission is added to the purge queue. After the waiting period ends, the submission is purged.",
    "For more information on this process, see":
      "For more information on this process, see",
    "Document retention tabs": "Document retention tabs",
    "Document Retention Policy": "Document Retention Policy",
    "Targeted Purge": "Targeted Purge",
    "Draft Submission Retention": "Draft Submission Retention",
    "By default, documents are kept in your account indefinitely. You can enable a document retention policy to set the number of days that completed, declined, and expired submissions are kept.":
      "By default, documents are kept in your account indefinitely. You can enable a document retention policy to set the number of days that completed, declined, and expired submissions are kept.",
    "Enable document retention policy": "Enable document retention policy",
    "How it works:": "How it works:",
    "After a submission reaches its retention limit, it is placed in the purge queue and permanently deleted after the purge waiting days period.":
      "After a submission reaches its retention limit, it is placed in the purge queue and permanently deleted after the purge waiting days period.",
    "Define retention per submission status":
      "Define retention per submission status",
    Completed: "Completed",
    Declined: "Declined",
    Expired: "Expired",
    "Keep for this many days": "Keep for this many days",
    "Purge waiting days": "Purge waiting days",
    "How many days after a submission enters the purge queue before it is permanently deleted.":
      "How many days after a submission enters the purge queue before it is permanently deleted.",
    "Remove fields and metadata": "Remove fields and metadata",
    "Strip all form field values and document metadata when the submission is purged.":
      "Strip all form field values and document metadata when the submission is purged.",
    "Redact personally identifiable information":
      "Redact personally identifiable information",
    "Requires Remove fields and metadata to be enabled.":
      "Requires Remove fields and metadata to be enabled.",
    "Find and purge specific submissions. Search below to locate submissions, then add them to the purge queue.":
      "Find and purge specific submissions. Search below to locate submissions, then add them to the purge queue.",
    "Process Purge Now": "Process Purge Now",
    "Process Result:": "Process Result:",
    drafts_soft_deleted: "drafts_soft_deleted",
    auto_queued: "auto_queued",
    purged: "purged",
    "Sender name": "Sender name",
    "Subject / reference no.": "Subject / reference no.",
    "All statuses": "All statuses",
    "Purge status: all": "Purge status: all",
    "Not queued": "Not queued",
    Queued: "Queued",
    "Search Button": "Search",
    Sender: "Sender",
    Subject: "Subject",
    Status: "Status",
    "Created at": "Created at",
    "Purge status": "Purge status",
    Action: "Action",
    "No submissions found.": "No submissions found.",
    "Add to queue": "Add to queue",
    "Add selected to purge queue": "Add selected to purge queue",
    "Purge Queue": "Purge Queue",
    "Submissions currently scheduled for permanent deletion.":
      "Submissions currently scheduled for permanent deletion.",
    Submission: "Submission",
    "Submission status": "Submission status",
    "Queued by": "Queued by",
    "Queued at": "Queued at",
    "No queue entries found.": "No queue entries found.",
    "By default, draft submissions are retained for 30 days from creation. Enable a custom retention policy to define the number of days drafts are kept in the Draft folder.":
      "By default, draft submissions are retained for 30 days from creation. Enable a custom retention policy to define the number of days drafts are kept in the Draft folder.",
    "Set the draft submission retention policy":
      "Set the draft submission retention policy",
    "Define the number of days to keep submissions in the Draft folder before they are cleared.":
      "Define the number of days to keep submissions in the Draft folder before they are cleared.",
    "Failed to load document retention data.":
      "Failed to load document retention data.",
    "Document retention policy updated successfully.":
      "Document retention policy updated successfully.",
    "Failed to update document retention policy.":
      "Failed to update document retention policy.",
    "Failed to fetch submissions.": "Failed to fetch submissions.",
    "Please select at least one submission.":
      "Please select at least one submission.",
    "Successfully added submissions to purge queue.":
      "Successfully added submissions to purge queue.",
    "Failed to add submissions to purge queue.":
      "Failed to add submissions to purge queue.",
    "Queue item not found.": "Queue item not found.",
    "Purge entry cancelled successfully.":
      "Purge entry cancelled successfully.",
    "Failed to cancel purge queue item.": "Failed to cancel purge queue item.",
    "Purge process completed.": "Purge process completed.",
    "Failed to process purge now.": "Failed to process purge now.",
  },
  ar: {
    settings: "الإعدادات",
    home: "الصفحة الرئيسية",
    landing: "الموقع التعريفي",
    configureLanding: "قم بتكوين إعدادات صفحة الهبوط الخاصة بك.",
    account: "الحساب",
    manageAccount: "إدارة إعدادات حسابك.",
    tsaSettings: "إعدادات TSA",
    adjustDsgSettings: " قم بضبط إعدادات DSG الخاصة بك.",
    careers: "الوظائف",
    exploreCareers: "استكشاف فرص العمل.",
    jobs: "الوظائف",
    exploreJobs: "استكشاف الوظائف المتاحة.",
    applicants: "المتقدمون",
    manageApplicants: "إدارة المتقدمين للوظائف.",
    blogs: "المدونات",
    manageBlogs: "إدارة منشورات مدونتك.",
    news: "الأخبار",
    companyCertificate: "شهادة الشركة",
    viewCompanyCertifications: "عرض شهادات الشركة.",
    companyFiles: "ملفات الشركة",
    accessCompanyFiles: "الوصول إلى ملفات الشركة.",
    memberships: "العضويات",
    manageMemberships: "إدارة العضويات.",
    services: "الخدمات",
    exploreServices: "استكشاف خدماتنا.",
    contactUs: "اتصل بنا",
    getInTouch: "تواصل معنا.",
    faqs: "الأسئلة الشائعة",
    frequentlyAskedQuestions: "الأسئلة المتكررة.",
    ourValues: "قيمنا",
    learnAboutValues: "تعرف على قيمنا.",
    newsletterSubscription: "اشتراك النشرة الإخبارية",
    manageNewsletterSubscriptions: "إدارة اشتراكات النشرة الإخبارية.",
    customPages: "الصفحات المخصصة",
    createManageCustomPages: "إنشاء وإدارة الصفحات المخصصة.",
    customers: "العملاء",
    manageCustomerInformation: "إدارة معلومات العملاء.",
    partners: "الشركاء",
    viewPartners: "عرض شركائنا.",
    teamMembers: "أعضاء الفريق",
    meetTeamMembers: "تعرف على أعضاء فريقنا.",
    tutorials: "الدروس",
    accessTutorials: "الوصول إلى الدروس.",
    pagesIntroductions: "مقدمات الصفحات",
    managePagesIntroductions: "إدارة جميع مقدمات الصفحات.",
    socialMedia: "وسائل التواصل الاجتماعي",
    manageSocialMediaLinks: "إدارة روابط وسائل التواصل الاجتماعي.",
    generalSettings: "الإعدادات العامة",
    adjustGeneralSettings: "ضبط الإعدادات العامة.",
    "Manage Landing Slider ": "إدارة شريط التمرير للصفحة المقصودة",
    "SiteMap URL": "رابط خريطة الموقع",
    "Manage SiteMap URL ": "إدارة رابط خريطة الموقع",
    "Adjust Landing General Settings": "ضبط الإعدادات العامة للصفحة المقصودة",
    "General Settings": "الإعدادات العامة",
    "Configure General Settings": "تكوين الإعدادات العامة",
    DsgSettings: "إعدادات DSG",
    "Log copied to clipboard!": "تم نسخ السجل إلى الحافظة!",
    "Failed to copy log.": "فشل نسخ السجل.",
    "Failed to download log.": "فشل تنزيل السجل.",
    "Audit Logs": "سجلات التدقيق",
    "Activity Type": "نوع النشاط",
    "Recipient": "مستلم",
    "Template": "قالب",
    "User": "مستخدم",
    "Personalization": "تخصيص",
    "Setting": "الإعداد",
    "Login": "تسجيل الدخول",
    "Folder": "مجلد",
    "Register": "تسجيل",
    "Document": "مستند",
    "Event Date": "تاريخ الحدث",
    "View and manage audit logs": "عرض وإدارة سجلات التدقيق",
    "Bulk Actions Logs": "سجلات الإجراءات المجمعة",
    "View bulk actions logs": "عرض سجلات الإجراءات المجمعة",
    "Type of Action": "نوع الإجراء",
    Summary: "الملخص",
    Administrator: "المسؤول",
    "Date and Time": "التاريخ والوقت",
    "No Bulk Actions": "لا توجد إجراءات مجمعة",
    "There are no Bulk Actions to display": "لا توجد إجراءات مجمعة للعرض",
    "View the status of pending and completed bulk actions. Download CSV logs of changes made":
      "اعرض حالة الإجراءات المجمعة المعلقة والمكتملة. قم بتنزيل سجلات التغييرات بصيغة CSV",
    "Roles & Permissions": "الأدوار والصلاحيات",
    "Manage roles and permission access": "إدارة الأدوار وصلاحيات الوصول",
    "Select a role to manage access": "اختر دورا لإدارة الوصول",
    Roles: "الأدوار",
    Permissions: "الصلاحيات",
    "Selected Role": "الدور المحدد",
    "Select a role to manage permissions": "اختر دورا لإدارة الصلاحيات",
    "All Permissions": "كل الصلاحيات",
    "Select All": "تحديد الكل",
    "Search permissions": "ابحث في الصلاحيات",
    "Add Role": "إضافة دور",
    "Edit Role": "تعديل الدور",
    "Delete Role": "حذف الدور",
    "Create Role": "إنشاء دور",
    "Update Role": "تحديث الدور",
    "Role Name": "اسم الدور",
    "Role Name (English)": "اسم الدور (بالإنجليزية)",
    "Role Name (Arabic)": "اسم الدور (بالعربية)",
    Create: "إنشاء",
    Update: "تحديث",
    Cancel: "إلغاء",
    "No roles found": "لا توجد أدوار",
    "Untitled Role": "دور بدون اسم",
    "No permissions found": "لا توجد صلاحيات",
    "Save Permissions": "حفظ الصلاحيات",
    "Saving...": "جاري الحفظ...",
    "Please select a role first": "يرجى اختيار دور أولا",
    "Role name is required": "اسم الدور مطلوب",
    "Delete this role?": "هل تريد حذف هذا الدور؟",
    "Failed to load roles and permissions": "فشل تحميل الأدوار والصلاحيات",
    "Failed to load role permissions": "فشل تحميل صلاحيات الدور",
    "Failed to create role": "فشل إنشاء الدور",
    "Role created successfully": "تم إنشاء الدور بنجاح",
    "Failed to update role": "فشل تحديث الدور",
    "Role updated successfully": "تم تحديث الدور بنجاح",
    "Failed to delete role": "فشل حذف الدور",
    "Role deleted successfully": "تم حذف الدور بنجاح",
    "Failed to save permissions": "فشل حفظ الصلاحيات",
    "Permissions saved successfully": "تم حفظ الصلاحيات بنجاح",
    "Roles & Permissions Icon": "أيقونة الأدوار والصلاحيات",
    "Document Retention": "الاحتفاظ بالمستندات",
    "Manage document retention policies": "إدارة سياسات الاحتفاظ بالمستندات",
    "Document Retention Icon": "أيقونة الاحتفاظ بالمستندات",
    "Bulk Actions Icon": "أيقونة الإجراءات المجمعة",
    "Audit Logs Icon": "أيقونة سجلات التدقيق",
    "Account Icon": "أيقونة الحساب",
    "Right Arrow Icon": "أيقونة السهم",
    "DsgSettings Icon": "أيقونة إعدادات DSG",
    "General Settings Icon": "أيقونة الإعدادات العامة",
    "Download Backups": "تنزيل النسخ الاحتياطية",
    "Download and manage system backups": "تنزيل وإدارة النسخ الاحتياطية للنظام",
    "Download Backups Icon": "أيقونة تنزيل النسخ الاحتياطية",
    "Backup for Workflow": "نسخ احتياطي للتدفق",
    "Backup for Landing": "نسخ احتياطي للموقع التعريفي",
    "Backup Code": "نسخ احتياطي للكود",
    "Backup DB Schema": "نسخ احتياطي لهيكل قاعدة البيانات",
    "Backup Full DB": "نسخ احتياطي كامل لقاعدة البيانات",
    "Export the application backend codebase as a downloadable archive.":
      "تصدير الكود الخلفي للتطبيق كأرشيف قابل للتنزيل.",
    "Export the database schema structure without full data.":
      "تصدير هيكل قاعدة البيانات دون البيانات الكاملة.",
    "Export a complete database backup including all data.":
      "تصدير نسخة احتياطية كاملة لقاعدة البيانات بما في ذلك جميع البيانات.",
    "Generate and download system backups. Each export is prepared on demand and the download link is valid for a short time.":
      "إنشاء وتنزيل النسخ الاحتياطية للنظام. يتم تجهيز كل تصدير عند الطلب ويكون رابط التنزيل صالحاً لفترة قصيرة.",
    "Preparing export...": "جاري تجهيز التصدير...",
    "Downloading...": "جاري التنزيل...",
    Download: "تنزيل",
    "Create New Export": "إنشاء تصدير جديد",
    Retry: "إعادة المحاولة",
    "Failed to start export.": "فشل بدء التصدير.",
    "Failed to check export status.": "فشل التحقق من حالة التصدير.",
    "Failed to download export file.": "فشل تنزيل ملف التصدير.",
    "Export failed. Please try again.": "فشل التصدير. يرجى المحاولة مرة أخرى.",
    "This export is taking longer than expected. Please try again later.":
      "يستغرق هذا التصدير وقتاً أطول من المتوقع. يرجى المحاولة لاحقاً.",
    "Document and Submission Retention Policy":
      "سياسة الاحتفاظ بالمستندات والإرسالات",
    "Set your account's document retention policy or purge individual submissions. Purging permanently removes documents from completed, declined, and expired submissions.":
      "قم بتحديد سياسة الاحتفاظ بالمستندات لحسابك أو حذف إرسالات محددة. يؤدي الحذف إلى إزالة المستندات نهائيا من الإرسالات المكتملة والمرفوضة والمنتهية.",
    "To start, the submission is added to the purge queue. After the waiting period ends, the submission is purged.":
      "للبدء، تتم إضافة الإرسال إلى قائمة الحذف. بعد انتهاء فترة الانتظار، يتم حذف الإرسال.",
    "For more information on this process, see":
      "لمزيد من المعلومات حول هذه العملية، راجع",
    "Document retention tabs": "تبويبات الاحتفاظ بالمستندات",
    "Document Retention Policy": "سياسة الاحتفاظ بالمستندات",
    "Targeted Purge": "حذف موجّه",
    "Draft Submission Retention": "الاحتفاظ بمسودات الإرسال",
    "By default, documents are kept in your account indefinitely. You can enable a document retention policy to set the number of days that completed, declined, and expired submissions are kept.":
      "افتراضيا، يتم الاحتفاظ بالمستندات في حسابك بشكل دائم. يمكنك تفعيل سياسة احتفاظ لتحديد عدد الأيام للاحتفاظ بالإرسالات المكتملة والمرفوضة والمنتهية.",
    "Enable document retention policy": "تفعيل سياسة الاحتفاظ بالمستندات",
    "How it works:": "كيف تعمل:",
    "After a submission reaches its retention limit, it is placed in the purge queue and permanently deleted after the purge waiting days period.":
      "بعد أن يصل الإرسال إلى حد الاحتفاظ، يتم وضعه في قائمة الحذف ثم حذفه نهائيا بعد فترة انتظار الحذف.",
    "Define retention per submission status":
      "تحديد مدة الاحتفاظ حسب حالة الإرسال",
    Completed: "مكتمل",
    Declined: "مرفوض",
    Expired: "منتهي",
    "Keep for this many days": "الاحتفاظ لمدة (بالأيام)",
    "Purge waiting days": "أيام انتظار الحذف",
    "How many days after a submission enters the purge queue before it is permanently deleted.":
      "عدد الأيام بعد دخول الإرسال إلى قائمة الحذف قبل حذفه نهائيا.",
    "Remove fields and metadata": "إزالة الحقول والبيانات الوصفية",
    "Strip all form field values and document metadata when the submission is purged.":
      "إزالة جميع قيم الحقول وبيانات المستند الوصفية عند حذف الإرسال.",
    "Redact personally identifiable information": "إخفاء المعلومات الشخصية",
    "Requires Remove fields and metadata to be enabled.":
      "يتطلب تفعيل خيار إزالة الحقول والبيانات الوصفية.",
    "Find and purge specific submissions. Search below to locate submissions, then add them to the purge queue.":
      "ابحث واحذف إرسالات محددة. استخدم البحث أدناه للعثور على الإرسالات ثم أضفها إلى قائمة الحذف.",
    "Process Purge Now": "تنفيذ الحذف الآن",
    "Process Result:": "نتيجة التنفيذ:",
    drafts_soft_deleted: "المسودات المحذوفة مبدئيا",
    auto_queued: "تمت إضافته تلقائيا",
    purged: "المحذوف نهائيا",
    "Sender name": "اسم المرسل",
    "Subject / reference no.": "الموضوع / الرقم المرجعي",
    "All statuses": "كل الحالات",
    "Purge status: all": "حالة الحذف: الكل",
    "Not queued": "غير موجود في القائمة",
    Queued: "موجود في القائمة",
    "Search Button": "بحث",
    Sender: "المرسل",
    Subject: "الموضوع",
    Status: "الحالة",
    "Created at": "تاريخ الإنشاء",
    "Purge status": "حالة الحذف",
    Action: "الإجراء",
    "No submissions found.": "لم يتم العثور على إرسالات.",
    "Add to queue": "إضافة إلى القائمة",
    "Add selected to purge queue": "إضافة المحدد إلى قائمة الحذف",
    "Purge Queue": "قائمة الحذف",
    "Submissions currently scheduled for permanent deletion.":
      "الإرسالات المجدولة حاليا للحذف النهائي.",
    Submission: "الإرسال",
    "Submission status": "حالة الإرسال",
    "Queued by": "تمت الإضافة بواسطة",
    "Queued at": "وقت الإضافة",
    "No queue entries found.": "لا توجد عناصر في قائمة الحذف.",
    "By default, draft submissions are retained for 30 days from creation. Enable a custom retention policy to define the number of days drafts are kept in the Draft folder.":
      "افتراضيا، يتم الاحتفاظ بمسودات الإرسال لمدة 30 يوما من تاريخ الإنشاء. فعّل سياسة مخصصة لتحديد عدد الأيام التي تبقى فيها المسودات داخل مجلد المسودات.",
    "Set the draft submission retention policy":
      "تحديد سياسة الاحتفاظ بمسودات الإرسال",
    "Define the number of days to keep submissions in the Draft folder before they are cleared.":
      "حدد عدد الأيام للاحتفاظ بالإرسالات في مجلد المسودات قبل إزالتها.",
    "Failed to load document retention data.":
      "فشل تحميل بيانات الاحتفاظ بالمستندات.",
    "Document retention policy updated successfully.":
      "تم تحديث سياسة الاحتفاظ بالمستندات بنجاح.",
    "Failed to update document retention policy.":
      "فشل تحديث سياسة الاحتفاظ بالمستندات.",
    "Failed to fetch submissions.": "فشل جلب الإرسالات.",
    "Please select at least one submission.":
      "يرجى تحديد إرسال واحد على الأقل.",
    "Successfully added submissions to purge queue.":
      "تمت إضافة الإرسالات إلى قائمة الحذف بنجاح.",
    "Failed to add submissions to purge queue.":
      "فشلت إضافة الإرسالات إلى قائمة الحذف.",
    "Queue item not found.": "عنصر القائمة غير موجود.",
    "Purge entry cancelled successfully.": "تم إلغاء عنصر الحذف بنجاح.",
    "Failed to cancel purge queue item.": "فشل إلغاء عنصر من قائمة الحذف.",
    "Purge process completed.": "اكتملت عملية الحذف.",
    "Failed to process purge now.": "فشل تنفيذ الحذف الآن.",
  },
};
